import { Button, FormControl, FormField, FormItem, FormMessage, Input } from '@packages/ui';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import zod from 'zod';
import { Step } from './Step';
import { useTranslation } from 'react-i18next';

const formSchema = zod.object({
  email: zod.string().email().min(3).max(150),
});

type FormData = zod.infer<typeof formSchema>;

type Props = {
  defaultData?: FormData;
  onSubmit: (data: FormData) => void;
  isActive: boolean;
  isDone: boolean;
  onActivate: () => void;
};
export const StepEmail = ({ onSubmit, defaultData, isActive, isDone, onActivate }: Props) => {
  const form = useForm({
    defaultValues: defaultData,
    resolver: zodResolver(formSchema),
  });

  const { t } = useTranslation();

  return (
    <Step
      question="Summary"
      form={form}
      onNext={onSubmit}
      isActive={isActive}
      isDone={isDone}
      onActivate={onActivate}
      hideSubmit>
      <p>{t('wedding.summary1')}</p>
      <p>{t('wedding.summary2')}</p>

      <FormField
        control={form.control}
        name="email"
        render={({ field }) => {
          return (
            <FormItem className="mt-2">
              <FormControl>
                <Input
                  placeholder="max.mustermann@gmail.com"
                  disabled={!isActive}
                  className="w-full"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          );
        }}
      />
      <p className="text-sm text-muted-foregorund mt-4">{t('wedding.questionnaire_hint')}</p>
      <Button type="submit" variant={'gradient'} className="w-full mt-4">
        {t('createSpeech')}
      </Button>
    </Step>
  );
};
